import { Box, Grid, Icon, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoreRadioButton from "../../core/inputs/CoreRadioButton";
import Card1 from "../../core/layouts/Card1";
import CoreInput from "../../core/inputs/CoreInput";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  FETCH_DEED_ADDRESS_FAIL,
  FETCH_DEED_ADDRESS_SUCCESS,
  SEARCH_DEED_DETAIL_FAIL,
  SEARCH_DEED_DETAIL_SUCCESS,
} from "../../store/types/deedTypes";
import { resetDeedReducer } from "../../store/actions/deedAction";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import DeedProcessorDashBoardModal from "./DeedProcessorDashBoardModal";


export default function DeedProcessorDashboard() {
  const dispatch = useDispatch();

  const deedSearchSuccess = useSelector(
    (state) => state?.deed?.deedSearchSuccess,
  );
  const deedSearchError = useSelector((state) => state?.deed?.deedSearchError);
  const deedSearchMessage = useSelector(
    (state) => state?.deed?.deedSearchMessage,
  );
  const deedSearchData = useSelector((state) => state?.deed?.deedSearchData);

  const deedAddressSuccess = useSelector(
    (state) => state?.deed?.deedAddressSuccess,
  );
  const deedAddressError = useSelector(
    (state) => state?.deed?.deedAddressError,
  );
  const deedAddressMessage = useSelector(
    (state) => state?.deed?.deedAddressMessage,
  );
  const deedAddressData = useSelector((state) => state?.deed?.deedAddressData);

  const [searchBy, setSearchBy] = useState("name");
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [address, setAddress] = useState({
    District: null,
    "Sub-Division": null,
    "Police station": null,
    Mouza: null,
    Village: null,
    Area: null,
  });
  const [options, setOptions] = useState({
    District: [],
    "Sub-Division": [],
    "Police station": [],
    Mouza: [],
    Village: [],
    Area: [],
  });
  const [tableData, setTableData] = useState(null);
  const [tableColumns, setTableColumns] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleEyeClick = (row) => {
    setSelectedRow(row);
    setModalOpen(true);
  };

  const searchOptions = [
    { label: "By name", value: "name" },
    { label: "By address", value: "address" },
  ];

  useEffect(() => {
    dispatch(
      resetDeedReducer({
        deedSearchError: false,
        deedSearchMessage: null,
        deedSearchData: null,
      }),
    );
    fetchDeedAddress();
  }, []);

  useEffect(() => {
    if (deedSearchSuccess) {
      setTableColumns([
        {
          label: "Owner",
          name: "buyer_name",
        },
        {
          label: "Father",
          name: "buyer_father_name",
        },
        {
          label: "Property Address",
          name: "property_address",
        },
        {
          label: "Property Details",
          name: "property_registration_number",
        },
        {
          label: "Date of Registration",
          name: "date_of_registration",
        },
        {
          label: "Action",
          name: "action",
          view: (row) => (
            <IconButton onClick={() => handleEyeClick(row)}>
              <Icon>visibility</Icon>
            </IconButton>
          ),
        },
      ]);
      setTableData(
        deedSearchData?.map((item) => {
          return {
            ...item,
            id: item.obj_id,
          };
        }),
      );
      dispatch(
        resetDeedReducer({
          deedSearchSuccess: false,
        }),
      );
    }
    if (deedSearchError) {
      dispatch(
        resetDeedReducer({
          deedSearchError: false,
        }),
      );
      alert(deedSearchMessage);
    }
  }, [deedSearchSuccess, deedSearchError]);

  useEffect(() => {
    if (deedAddressData && deedAddressSuccess) {
      dispatch(
        resetDeedReducer({
          deedAddressSuccess: false,
        }),
      );
      let maxPriority = 0;
      for (let obj of Object.keys(getCleanJson(address))) {
        if (priority[obj] > maxPriority) {
          maxPriority = priority[obj];
        }
      }

      let nextObjName = Object.keys(priority).find(
        (key) => priority[key] === maxPriority + 1,
      );
      if (maxPriority === 6) {
        setTableColumns([
          { label: "Reg. Date", name: "Date of Registration" },
          { label: "Buyer Name", name: "Buyer Name" },
          { label: "Seller Name", name: "Seller Name" },
          { label: "Land Area", name: "Area" },
          { label: "Location", name: "Property Address (full location)" },
          {
            label: "Action",
            name: "action",
            view: (row) => (
              <IconButton onClick={() => handleEyeClick(row)}>
                <Icon>visibility</Icon>
              </IconButton>
            ),
          },
        ]);
        setTableData(
          deedAddressData?.map((item) => ({
            ...item,
            id: item._id,
          })),
        );
      } else {
        setOptions((prev) => ({
          ...prev,
          [nextObjName]: deedAddressData,
        }));
      }
    }
  }, [deedAddressSuccess]);

  useEffect(() => {
    fetchDeedAddress();
  }, [JSON.stringify(address)]);

  useEffect(() => {
    if (deedAddressError) {
      dispatch(
        resetDeedReducer({
          deedAddressError: false,
        }),
      );
      alert(deedAddressMessage);
    }
  }, [deedAddressError]);

  const fetchDeedAddress = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/fetch/deed/address",
        { address: getCleanJson(address) },
        null,
        null,
        FETCH_DEED_ADDRESS_SUCCESS,
        FETCH_DEED_ADDRESS_FAIL,
        true,
        false,
      ),
    );
  };

  const handleAddressChange = (key, val) => {
    const currentPriority = priority[key];

    const newAddress = { ...address, [key]: val ? val.value : null };
    const newOptions = { ...options };

    Object.keys(priority).forEach((pKey) => {
      if (priority[pKey] > currentPriority) {
        newAddress[pKey] = null;
        newOptions[pKey] = [];
      }
    });

    setAddress(newAddress);
    setOptions(newOptions);
    setTableData(null);
    setTableColumns([]);
  };

  const handleSearchByChange = (event) => {
    setTableData(null);
    setTableColumns([]);
    setSearchBy(event.target.value);
  };

  const handleSearch = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/deed/search",
        {
          name: name,
          fatherName: fatherName,
        },
        null,
        null,
        SEARCH_DEED_DETAIL_SUCCESS,
        SEARCH_DEED_DETAIL_FAIL,
        true,
        false,
      ),
    );
  };

  return (
    <Box style={{ width: "100%", height: "calc(100vh - 96px)" }}>
      <Box style={{ padding: 16, height: "100%" }}>
        <Card1
          title="Deed document Search"
          style={{
            backgroundColor: "white",
            textAlign: "left",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box style={{ marginTop: 8 }}>
            <CoreRadioButton
              name="searchBy"
              value={searchBy}
              onChange={handleSearchByChange}
              options={searchOptions}
              row={true}
            />
          </Box>

          <Box
            style={{
              marginTop: 0,
              maxWidth: searchBy === "name" ? 800 : "100%",
            }}
          >
            <Grid
              container
              columnSpacing={2}
              rowSpacing={3}
              alignItems="flex-end"
            >
              {searchBy === "name" ? (
                <>
                  <Grid item xs={12} sm={4}>
                    <CoreInput
                      label="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <CoreInput
                      label="Father name"
                      value={fatherName}
                      onChange={(e) => setFatherName(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleSearch();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Box style={{ marginBottom: 8 }}>
                      <CoreContainedButton
                        onClick={handleSearch}
                        disabled={!name.trim()}
                        style={{
                          height: "35px",
                          paddingLeft: "20px",
                          paddingRight: "12px",
                          fontWeight: "600",
                          textTransform: "none",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        Search
                        <Icon style={{ fontSize: "1.2rem", marginLeft: "8px" }}>
                          arrow_forward
                        </Icon>
                      </CoreContainedButton>
                    </Box>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="District"
                      label="District"
                      value={address.District}
                      onChange={(id, val) =>
                        handleAddressChange("District", val)
                      }
                      options={options?.District?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="Sub-Division"
                      label="Sub-Division"
                      value={address["Sub-Division"]}
                      onChange={(id, val) =>
                        handleAddressChange("Sub-Division", val)
                      }
                      options={options?.["Sub-Division"]?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="Police station"
                      label="Police station"
                      value={address["Police station"]}
                      onChange={(id, val) =>
                        handleAddressChange("Police station", val)
                      }
                      options={options?.["Police station"]?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="Mouza"
                      label="Mouza"
                      value={address.Mouza}
                      onChange={(id, val) => handleAddressChange("Mouza", val)}
                      options={options?.Mouza?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="Village"
                      label="Village"
                      value={address.Village}
                      onChange={(id, val) =>
                        handleAddressChange("Village", val)
                      }
                      options={options?.Village?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <CoreAutoComplete
                      id="Area"
                      label="Land"
                      value={address.Area}
                      onChange={(id, val) => handleAddressChange("Area", val)}
                      options={options?.Area?.map((item) => {
                        return {
                          label: item,
                          value: item,
                        };
                      })}
                      placeholder="Select"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>

          <Box style={{ marginTop: 24, flex: 1, overflowY: "auto" }}>
            {tableData?.length > 0 && (
              <CoreDataTable
                columns={tableColumns}
                dataRows={tableData}
                selectable={false}
                showToolbar={false}
              />
            )}
          </Box>
        </Card1>
      </Box>
      <DeedProcessorDashBoardModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        data={selectedRow}
      />
    </Box>
  );
}

const priority = {
  District: 1,
  "Sub-Division": 2,
  "Police station": 3,
  Mouza: 4,
  Village: 5,
  Area: 6,
};

const getCleanJson = (obj) => {
  const clean = (item) => {
    if (item === null || item === undefined) return null;
    if (Array.isArray(item)) {
      const arr = item.map(clean).filter((v) => v !== null);
      return arr.length > 0 ? arr : null;
    } else if (typeof item === "object") {
      const cleaned = Object.entries(item).reduce((a, [k, v]) => {
        const val = clean(v);
        if (val !== null) a[k] = val;
        return a;
      }, {});
      return Object.keys(cleaned).length > 0 ? cleaned : null;
    }
    return item !== "" ? item : null;
  };

  const result = clean(obj);
  if (result === null) return Array.isArray(obj) ? [] : {};
  return result;
};
